module.exports = __webpack_public_path__ + "static/media/ios-mail-open.acd756e2.svg";